































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import HtmlEditor from '@tinymce/tinymce-vue'

import { CaseWithMessages } from '@/queries/cases.graphql'
import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor.tsx'
import AuthorizationMixin from '@/routing/AuthorizationMixin'
import { Process } from '../../store/workflow/types'
import { LetterTemplate } from '@/graphql-schema'

export default mixins(AuthorizationMixin).extend({
  components: {
    Artifacts,
    Editor,
    HtmlEditor,
  },
  data() {
    return {
      configUpdate: 1,
    }
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    treatmentCode: {
      type: String,
      required: true,
      validator(value: string) {
        return ['ipt', 'cbt', 'cr', 'expo', 'counseling'].indexOf(value) > -1
      },
    },
    code: {
      type: String,
      required: true,
    },
  },
  apollo: {
    pickedCase: {
      query() {
        return CaseWithMessages
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
  },
  /*
  mounted() {
    setTimeout(() => {
      this.configUpdate = this.configUpdate + 1
      console.log('mounted EditorForCockpit.vue ' + this.configUpdate)
    }, 1000)
  },
  */
  methods: {
    getCaseTemplates(): any[] {
      const templates = this.$store.getters['letterTemplates/storedObjectsArray']
      if (!this.pickedCase) {
        return templates
      }
      // get genders
      let myGender = this.pickedCase?.me?.gender?.toLowerCase()
      if (myGender == undefined) {
        myGender = this.$store.getters.currentUser?.gender?.toLowerCase()
      }
      const patientGender = this.pickedCase?.patient?.gender?.toLowerCase()
      return templates
        .filter((t: any) => {
          return (
            t.type?.toLowerCase() === 'letter' &&
            (t.gender_of_writer === null || t.gender_of_writer?.toLowerCase() === myGender) &&
            (t.gender_of_reader === null || t.gender_of_reader?.toLowerCase() === patientGender)
          )
        })
        .map((t: any) => {
          const title: string =
            typeof t.treatment_code === 'string'
              ? `${t.treatment_code.toUpperCase()}: ${t.title}`
              : t.title
          return { ...t, title }
        })
        .sort((a: LetterTemplate, b: LetterTemplate) =>
          (a.languageCode + ':' + a.title).localeCompare(b.languageCode + ':' + b.title)
        )
    },
  },
  computed: {
    where(): object {
      return { case_id: this.caseId, code: this.code }
    },
    defaults(): object {
      return { ...this.where, sender_id: this.$store.getters.currentUserId }
    },
    templates(): any[] {
      if (this.treatmentCode) {
        return this.getCaseTemplates().filter(t => t.treatment_code === this.treatmentCode)
      } else {
        return this.getCaseTemplates()
      }
    },
    configs(): any {
      const templates = this.templates
      const directionality = this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
      return {
        branding: false,
        directionality,
        height: 400,
        language: this.$i18n.locale,
        plugins: 'template textcolor colorpicker',
        toolbar:
          'undo redo | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify',
        templates,
      }
    },
  },
  created() {
    const letters: any[] = this.$store.getters['letters/filterBy'](this.where)

    // load all letters
    this.$store.dispatch({ type: 'letters/pullObjects', setLoading: false }).then(data => {
      console.debug('loaded letters', data)
      const filteredLetters: any[] = this.$store.getters['letters/filterBy'](this.where)
      // create a letter, if none exists. this avoids jumping between the two editors.
      if (filteredLetters.length === 0) {
        return this.$store.dispatch({
          type: 'letters/pushObject',
          object: { ...this.defaults },
        })
      }
    })
  },
  watch: {
    configs(): void {
      // https://michaelnthiessen.com/force-re-render/
      this.configUpdate += 1
    },
    caseId(): void {
      // https://michaelnthiessen.com/force-re-render/
      this.configUpdate += 1
    },
    number(): void {
      // https://michaelnthiessen.com/force-re-render/
      this.configUpdate += 1
    },
  },
})
